module.exports = __webpack_public_path__ + "static/media/BTCB-BNB.c75e6c1d.svg";